import { useEffect, useState, forwardRef, useCallback } from "react";

import {
  Card,
  CardContent,
  Typography,
  CardActions,
  Grid,
  Divider,
  IconButton,
  Tooltip,
  Dialog,
  DialogActions,
  Button,
  DialogContent,
  Slide,
  DialogContentText,
  DialogTitle,
  TablePagination,
  Modal,
  Box,
  MenuItem,
  TextField,
  CircularProgress,
  CardMedia
} from '@mui/material';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useMemo } from "react-router-dom";

import ShoppingCart from '@mui/icons-material/ShoppingCart';
import CloseIcon from '@mui/icons-material/Close';

import CustomLayout from "views/CustomLayout";
import CustomBreadcrumbs from "components/Breadcrumbs";
import DropdownMenu from "components/DropdownMenu";
import DynamicFilter from "containers/DynamicFilter";
import Loader from 'components/Loader';
import axiosInstance from "configs/axiosConfig";
import { APIRouteConstants } from 'constants/routeConstants';

import { filterCategory } from 'constants/appData/filters'
import { productList } from 'constants/appData/productList'
// import { handleOpenAuthDialog } from "utils/auth";
import { getAccessToken } from "utils";
import { updateCartCount } from "utils/website";
import { addCartItemsToLocalStorage, getCartCountFromLocalStorage, getCartFromLocalStorage, getCartItemsFromLocalStorage, getCartSummaryFromLocalStorage } from "utils/cart";
import { useSnackbar } from "notistack";
import { GLOBAL_CURRENCY } from "constants/appConstants";
import { ReactComponent as NoData } from 'assets/svgs/NoData.svg';
import { isMobile } from "react-device-detect";
import FilterDropdown from "containers/DynamicFilter/FilterDropdown";
import FlagContent from "components/InappropriateContent";
import { useAuth } from "oidc-react";
import FloatingCartBar from "views/Cart/CartFooter";
import instance from "configs/axiosConfig"; import { useFooterVisibility } from "Context/FooterContext";
import { formatCurrencyNew } from "utils/helper";
import CategoryBar from "./component/CategoryBar ";
import VariantSelector from "./component/VarientSelector";
;
// import FlagContent from "components/InappropriateContent";

// let formatCurrency = new Intl.NumberFormat(undefined, {
//   style: 'currency',
//   currency: GLOBAL_CURRENCY.code,
//   currencyDisplay: 'narrowSymbol',
//   minimumFractionDigits: 2
// });


function formatCurrency(currencyCode, currencyDisplay = 'narrowSymbol') {
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: currencyCode ? currencyCode : GLOBAL_CURRENCY.code,
    currencyDisplay: currencyDisplay,
    minimumFractionDigits: 2
  });
}


const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const FilterBar = ({
  totalCount,
  pageCount,
  handleChangePage,
  selectSort,
  sorting,
  filterCategory,
}) => (
  <Grid container justifyContent={"space-between"} className="filter-bar-wrapper">
    <Grid item xs={2.2} sm={3}  >
      <DropdownMenu
        name="Sort"
        menuList={[
          {
            value: "new",
            label: "What's New",
          },
          {
            value: "most_popular",
            label: "Most Popular",
          },
          {
            value: "price_low_to_high",
            label: "Price: Low to High",
          },
          {
            value: "price_high_to_low",
            label: "Price: High to Low",
          },
        ]}
        handleSelect={(e) => {
          selectSort(e);
        }}
        selectedMenu={sorting}
      />
    </Grid>
    <Grid item xs={2.5} sm={2.5}>
      <FilterDropdown filterCategory={filterCategory} type={"filter"} />
    </Grid>
  </Grid>
);

const ProductCard = ({
  varient_colors,
  varient_sizes,
  product,
  count,
  image,
  name,
  brand,
  price,
  handleClick,
  handleAddToCart,
  cart,
  token,
  singleVarient
}) => {

  const currentCart = getCartItemsFromLocalStorage();
  const currentCartItem = currentCart && currentCart.filter(item => item?.id === product?.id);
  const currentCartItemWithToken = cart && cart.filter(item => item?.product === product?.id);

  const currentQuantity = currentCartItem?.[0]?.quantity;
  const currentQuantityWithToken = currentCartItemWithToken?.[0]?.quantity;

  const quantity = token ? currentQuantityWithToken : currentQuantity;

  const { websiteInfo } = useSelector(state => state.webDetails);

  const [isWebsiteFunctional, setIsWebsiteFunctional] = useState(false);
  const [hasCheckedWebsiteInfo, setHasCheckedWebsiteInfo] = useState(false);

  useEffect(() => {
    if (websiteInfo) {
      setIsWebsiteFunctional(websiteInfo.status ?? false);
      setHasCheckedWebsiteInfo(true);
    }
  }, [websiteInfo]);


  const hasVariants = (varient_colors?.length > 0 || varient_sizes?.length > 0);


  const hasSingleSize = varient_colors?.filter((item) => item.name != '')?.length === 1;
  const hasSingleColor = varient_sizes?.filter((item) => item.name != '')?.length === 1;
  const currentVarient = {...product?.variants[0], product_name: product?.name};

console.log("varient_colors",varient_sizes)
  return (
    <Card
      className="content-card"
      onClick={handleClick}
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        border: "1px solid #f7f7f7",
        filter: "drop-shadow(5px 5px 5px #cccbcb29)",
        cursor: "pointer"
      }}
    >

      {/* IMAGE */}
      <div className="overlay-card-wrapper">
        <div style={{ height: "240px", marginBottom: "1rem" }}>
          <CardMedia
            component="img"
            sx={{ objectFit: "contain", height: "100%", width: "100%" }}
            src={image}
            alt={name}
          />
        </div>

        {!count && (
          <div className="overlay-card">
            <Button style={{ backgroundColor: "rgba(255,255,255,0.8)" }} variant="outlined" color="error">
              <b>Out of Stock</b>
            </Button>
          </div>
        )}
      </div>

      {/* CONTENT */}
      <CardContent
        sx={{
          p: 2,
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between"
        }}
      >

        {/* Product Name */}
        <Typography
          sx={{
            fontSize: "0.95rem",
            mt: 2,
            minHeight: "40px",
            // maxHeight: "40px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            textTransform: "capitalize"
          }}
        >
          {name}
        </Typography>

        {/* Variant Selector */}
        {count > 0 && hasVariants && (
          <Grid container spacing={1} ml={0} mt={0}>
            <VariantSelector
              groupColors={varient_colors}
              groupSizes={varient_sizes}
            />
          </Grid>
        )}

        {/* Brand */}
        <Typography
          variant="subtitle2"
          color="text.secondary"
          sx={{
            fontSize: "0.9rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            mt: 0.6
          }}
        >
          {brand}
        </Typography>

        {/* Price */}
        <Typography variant="subtitle2" className="price">
          <b>{formatCurrencyNew(price || 0, websiteInfo?.currency_symbol)}</b>
        </Typography>

      </CardContent>

      {/* ACTIONS */}
      <CardActions sx={{ px: 2, pb: 2, display: "flex", justifyContent: "space-between" }}>
        {
                      console.log("singleVarient",singleVarient, !hasSingleSize,!hasSingleColor,count )}
        {(singleVarient&& !hasSingleSize && !hasSingleColor && count>0) ? (
          <Tooltip title="Add to Cart">
            <Button
              size="small"
              variant="outlined"
              onClick={(e) => {
                e.stopPropagation();
                handleAddToCart(currentVarient);
              }}
              sx={{ width: "100%" }}
              disabled={hasCheckedWebsiteInfo && (!isWebsiteFunctional || count === quantity)}
            >
              {console.log("currentVarient",currentVarient)}
              Add
            </Button>
          </Tooltip>
        ) : (
          <Button size="small" variant="outlined" sx={{ width: "100%" }}>
            View
          </Button>
        )}

        <FlagContent productName={name} product={product} />
      </CardActions>

    </Card>
  );
};


function queryStringToJSON(search) {
  if (!search) return {}
  var qs = search.slice(1);

  var pairs = qs.split('&');
  var result = {};
  pairs.forEach(function (p) {
    var pair = p.split('=');
    var key = pair[0];
    var value = decodeURIComponent(pair[1] || '');

    if (result[key]) {
      if (Object.prototype.toString.call(result[key]) === '[object Array]') {
        result[key].push(value);
      } else {
        result[key] = [result[key], value];
      }
    } else {
      result[key] = value;
    }
  });

  return JSON.parse(JSON.stringify(result));
};

const ProductList = ({ breadcrumbs }) => {

  const { isFooterVisible, hasInitialized, setHasInitialized } = useFooterVisibility();
  console.log("visible", isFooterVisible, hasInitialized)
  const auth = useAuth();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const webDetails = useSelector(state => state.webDetails);
  const { allCategories, refreshCart } = webDetails;
  const loggedInUser = useSelector(state => state.userDetails);
  const { doLogin, isAuthOpen } = loggedInUser
  const [filteredCategories, setFilteredCategory] = useState([]);
  const [selectedCategory, selectCategory] = useState();
  const [allProducts, setProductList] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  // const [askLogin, openAskLogin] = useState(false);
  const queryString = useLocation();
  const query = queryStringToJSON(queryString.search);
  const [sorting, selectSort] = useState('');
  const { enqueueSnackbar } = useSnackbar();
  const { search } = query;

  const [cartCount, setCartCount] = useState(null)
  const [cart, setCart] = useState(null)
  const [subTotal, setSubTotal] = useState(null)
  const naviagte = useNavigate()
  const [hasMobileUpdateModal, setHasMobileUpdateModal] = useState(false);

  const [productList, setProductListLocal] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [snackbarShown, setSnackbarShown] = useState(false);

  const fetchProductsByTableNumber = async () => {
    setLoading(true);

    let tableNumber = localStorage.getItem("number");
    if (!tableNumber) {
      console.warn("⚠️ No table number found in localStorage.");
      setProductListLocal([]);
      setMessage("");
      setLoading(false);
      return;
    }

    try {
      let res = await axiosInstance.get(APIRouteConstants.DASHBOARD.BULKQRSTATUS, {
        params: { number: tableNumber }
      });

      let { data } = res;

      if (data?.recent_pending_order_present === true && !snackbarShown) {
        enqueueSnackbar('For ease of ordering and billing, we recommend only one person per table to place orders.', { variant: 'error' })
        setSnackbarShown(true);
      } else {
        setMessage("");
      }

      setProductListLocal(data.results || []);
    } catch (error) {
      console.error("❌ Error fetching product list:", error);
      setProductListLocal([]);
      setMessage("");
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchProductsByTableNumber();
  }, []);
  useEffect(() => {
    setHasInitialized(true);
  }, []);

  useEffect(() => {
    const D6USERDATA = localStorage.getItem("d6_user_data")
    if (D6USERDATA == "false") {
      setHasMobileUpdateModal(true)
    }

  }, [webDetails])


  var token = getAccessToken();

  const filterCategory = (categories) => {
    let _categories = []
    let _filteredCategories = [];
    let categoryTypeSimple = true;
    for (let category of categories) {
      if (!category.parent) {
        _categories.push(category)
      }
    }
    for (let category of _categories) {
      let list = _.filter(categories, { parent: category.id })
      if (list.length > 0) categoryTypeSimple = false
      _filteredCategories.push({
        ...category,
        child: list
      })
    }

    setFilteredCategory({
      categories: _filteredCategories,
      type: categoryTypeSimple ? 'checkbox' : 'nested'
    })
  }

  useEffect(() => {
    if (allCategories.length > 0) {
      filterCategory(allCategories)
    }
  }, [allCategories.length])

  const getProductList = async (category) => {
    setLoader(true)
    let queryParams = {
      page: pageCount + 1
    }
    if (category) queryParams['category_name'] = category;
    if (sorting) queryParams['sort'] = sorting
    if (search) queryParams['query'] = search
    let res = await axiosInstance.get(APIRouteConstants.DASHBOARD.ALL_PRODUCT, {
      params: queryParams
    });
    let { data, response } = res;

    if (data && data.results) {
      const normalizeProduct = (item) => ({
        ...item,
        // keep original id (variant) but add normalized fields used by UI
        name: item?.product_name || item?.name,
        product_image: (item?.images && item.images[0]?.image) || item?.product_image,
      });
      const normalized = data.results.map(normalizeProduct);
      setProductList(normalized)
      setTotalCount(data.count);
      setPageCount(data.current_page - 1);
    }
    setLoader(false)
  }

  useEffect(() => {
    if (!_.isEmpty(query.category)) {
      selectCategory(query.category)
    }
  }, [query.category])

  useEffect(() => {
    if (!_.isEmpty(selectedCategory)) {
      getProductList(selectedCategory)
    } else getProductList()
  }, [selectedCategory, pageCount, sorting, search])

  const handleChangePage = (event, newPage) => {
    setPageCount(newPage)
  }

  const delay = ms => new Promise(
    resolve => setTimeout(resolve, ms)
  );

  const addToCart = async (product) => {
    setLoader(true)
    if (!token) {
      addCartItemsToLocalStorage(product)
      getProductList(selectedCategory)
      updateCartCount(true)
      // await delay(5000);
      enqueueSnackbar('Hey, this feels great! Product has been added to the cart.', { variant: 'success' })
    } else {
      let res = await axiosInstance.post(APIRouteConstants.DASHBOARD.ADD_TO_CART, {
        product_id: product.id
      });
      let { data, response } = res;

      if (response
        && response.status === 400
        && response.data) {
        if (response.data.error) {
          enqueueSnackbar(response.data.error, { variant: 'error' })
        } else
          for (let i in response.data) {
            enqueueSnackbar(_.capitalize(i) + ': ' + response.data[i][0], { variant: 'error' });
          }
      }

      if (data) {
        enqueueSnackbar('Hey, this feels great! Product has been added to the cart.', { variant: 'success' })
        updateCartCount(true)
      }
    }
    setLoader(false)
  }


  const getTableNumberFromURL = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get("number"); // Extracts 'table-1' from '?number=table-1'
  };

  useEffect(() => {
    const tableNumber = getTableNumberFromURL();

    if (tableNumber) {
      localStorage.setItem("number", tableNumber); // Store full value (e.g., 'table-1')
      console.log("Stored Table Number:", tableNumber);
    }
  }, []);

  const getCartCount = async () => {
    if (!token) {
      let count = getCartCountFromLocalStorage()
      const subTotal = getCartFromLocalStorage();
      setCartCount(count);
      setSubTotal(subTotal)
    } else {
      let res = await instance.get(APIRouteConstants.DASHBOARD.GET_CART_ITEMS);
      let { data, response } = res;

      let count = 0;
      if (data && data.cart_items) {
        for (let i of data.cart_items) {
          count = count + i.quantity
        }
        setCart(data.cart_items)
        setCartCount(count);
        setSubTotal(data?.subtotal_price)
      }
    }
  }
  useEffect(() => {
    getCartCount();
  }, [refreshCart])
  const handleViewCart = useCallback(() => {
    navigate("/cart");
  }, []);
  const [isAtNinetyPercent, setIsAtNinetyPercent] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsAtNinetyPercent(hasReachedNinetyPercentScroll());
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Initial check

    return () => window.removeEventListener("scroll", handleScroll); // Cleanup
  }, []);

  const hasReachedNinetyPercentScroll = () => {
    const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
    const scrolledPercentage = (scrollTop + clientHeight) / scrollHeight;
    return scrolledPercentage >= 0.87;
  };

  return (
    <CustomLayout>
      <Loader open={loader} />
      <div className="catalog-wrapper content-container">
        <CustomBreadcrumbs list={breadcrumbs} name="Products" />
        <Divider className="divider" />
        <CategoryBar allCategories={allCategories} handleSelect={selectCategory} selectedCategory={selectedCategory} setPageCount={setPageCount} />
        <Grid container spacing={1} className="main-content-wrapper" p={'0 5px !important'}>
          <Grid item md={3} className="category-wrapper" >
            <DynamicFilter
              filterCategory={[{
                title: "Categories",
                type: filteredCategories.type,
                items: filteredCategories.categories || [],
                selectedItem: selectedCategory,
                handleSelect: (category) => {
                  selectCategory(category)
                  if (!_.isEmpty(query.category) && query.category != category) {
                    navigate(`/products`)
                  }
                }
              }]}
            />
          </Grid>
          <Grid item md={9} className="catalog-list-wrapper">
            <div className="filter-wrapper">
              <FilterBar
                totalCount={totalCount}
                pageCount={pageCount}
                handleChangePage={handleChangePage}
                selectSort={selectSort}
                sorting={sorting}
                filterCategory={[{
                  title: "Categories",
                  type: filteredCategories.type,
                  items: filteredCategories.categories || [],
                  selectedItem: selectedCategory,
                  handleSelect: (category) => {
                    selectCategory(category)
                    if (!_.isEmpty(query.category) && query.category != category) {
                      navigate(`/products`)
                    }
                  }
                }]}
              />
              {/* <FilterDropdown 
                            filterCategory={[{
                                title: "Categories",
                                type: filteredCategories.type,
                                items: filteredCategories.categories || [],
                                selectedItem: selectedCategory,
                                handleSelect: (category) => {
                                    selectCategory(category)
                                    if (!_.isEmpty(query.category) && query.category != category) {
                                        navigate(`/products`)
                                    }
                                }
                            }]} 
                            /> */}
            </div>
            <Grid container className="catalog-list">
              {allProducts.length > 0 ? allProducts.map((product, i) => {
                const variants = product?.variants || [];
                const totalStock = variants?.reduce((sum, item) => {
                  return sum + (item.stock_count || 0);
                }, 0);



                // Unique Colors
                const groupColors = variants.reduce((acc, item) => {
                  const color = item.color;
                  if (color && !acc.some(c => c.name === color.name)) {
                    acc.push({
                      name: color.name,
                      hex: color.hex_code
                    });
                  }
                  return acc;
                }, []);

                // Unique Sizes
                const groupSizes = variants.reduce((acc, item) => {
                  const size = item.size;
                  if (size && !acc.some(s => s.name === size.name)) {
                    acc.push({
                      name: size.name,
                      category: size.category
                    });
                  }
                  return acc;
                }, []);

                return (
                  <>
                    {isMobile ? <Grid item xl={3} lg={4} md={6} sm={6} xs={6} mb={1}>
                      <ProductCard
                        info={webDetails}
                        token={token}
                        cart={cart}
                        product={product}
                        image={product?.product_image}
                        brand={product?.category_name}
                        name={product?.name}
                        price={(product.price===null ||product.price==='') ?variants[0]?.price:product.price}
                        mrp={product.price}
                        discount={product.discount}
                        count={totalStock}
                        singleVarient={variants?.length === 1}
                        varient_colors={groupColors}
                        varient_sizes={groupSizes}
                        handleClick={() => {
                          navigate(`/product/${variants[0]?.id || product?.id}`)
                        }}
                        handleAddToCart={(product) => {
                          addToCart(product)
                        }}
                      />
                    </Grid> : <Grid item xl={3} lg={4} md={6} sm={6} xs={12} mb={1}>
                      <ProductCard
                        token={token}
                        cart={cart}
                        product={product}
                        image={product?.product_image}
                        brand={product?.category_name}
                        name={product?.name}
                        price={(product.price===null ||product.price==='') ?variants[0]?.price:product.price}
                        mrp={product.price}
                        discount={product.discount}
                        count={totalStock}
                        varient_colors={groupColors}
                        varient_sizes={groupSizes}
                        singleVarient={variants?.length === 1}
                        handleClick={() => {
                          navigate(`/product/${variants[0]?.id || product?.id}`)
                        }}
                        handleAddToCart={(product) => {
                          addToCart(product)
                        }}
                      />
                    </Grid>
                    }
                    {(window.location.pathname === "/products" && (!isFooterVisible || [1, 2].includes(allProducts?.length)) && hasInitialized) && <FloatingCartBar totalCount={totalCount} cartCount={cartCount} subTotal={subTotal} onViewCart={handleViewCart} />}
                  </>
                )
              }) : <Grid container className="empty-wrapper">
                <div className="icon-wrapper">
                  <NoData />
                </div>
                <span className="title">
                  No Product Available
                </span> <br />
                {/* <span className="description">
                                Please add some products to your shopping cart before proceeding to checkout. 
                            </span> */}
                <span className="description">
                  Browse our shop categories to discover new arrivals and special offers.
                </span>
                {/* <div className='button-wrapper'>
                                <Button variant="contained" href='/products'>
                                    RETURN TO SHOP
                                </Button>
                            </div> */}
              </Grid>}
            </Grid>
            <Box mt={2}>
              <TablePagination
                rowsPerPageOptions={[]}
                component="div"
                count={totalCount}
                rowsPerPage={totalCount < 10 ? totalCount : 10}
                page={pageCount}
                onPageChange={handleChangePage}
                sx={{
                  '& .MuiTablePagination-actions': {
                    marginRight: 0,
                    marginLeft: "0px !important",
                  },
                  '& .MuiToolbar-root': {
                    paddingLeft: "0px !important",
                    marginLeft: "5px !important",
                  },
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </div>

      <D6UpdateMobileModal isDialogOpen={hasMobileUpdateModal} setDialogOpen={setHasMobileUpdateModal} />
    </CustomLayout>
  );
};



const D6UpdateMobileModal = ({ isDialogOpen, setDialogOpen }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [countryCode, setCountryCode] = useState("27"); // Default country code
  const [mobileNumber, setMobileNumber] = useState("");
  const [error, setError] = useState("");
  const handleUpdate = async () => {
    if (!mobileNumber) {
      setError("Mobile number is required.");
      return;
    }
    if (mobileNumber.length < 9 || mobileNumber.length > 15) {
      setError("Enter a valid mobile number (9 to 15 digits).");
      return;
    }
    const token = localStorage.getItem("u-access-token")
    setLoading(true);
    try {
      const response = await axiosInstance.put(APIRouteConstants.AUTH.D6_UPDATE_PHONE, {
        mobile_number: mobileNumber,
        country_code: countryCode,
      },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data) {
        localStorage.setItem("d6_user_data", JSON.stringify(true))
        setError("");
        setDialogOpen(false)
        // Navigate or take further actions on success
        window.location.reload()
      }
    } catch (error) {
      console.error("Error updating mobile number:", error);
      setError("Failed to update the mobile number. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setDialogOpen(false);
  };

  return (
    <>
      <Modal open={isDialogOpen}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "80%", sm: "75%", md: "50%", lg: "40%" },
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 3,
          }}
        >
          {/* Header Section */}
          <Grid container alignItems="center" spacing={0} sx={{ mb: 4 }}>
            <Typography variant="body1" textAlign="left" sx={{ width: "100%" }}>
              Please update your mobile number (mandatory)!
            </Typography>
          </Grid>

          {/* Modal Content */}
          <Grid container direction="column" alignItems="center">
            {/* Country Code Dropdown and Mobile Number Input */}
            <Grid item xs={12} sx={{ width: "100%", mb: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <TextField
                    size="small"
                    select
                    fullWidth
                    value={countryCode}
                    onChange={(e) => setCountryCode(e.target.value)}
                    label="Country Code"
                  >
                    <MenuItem value="27">27 (SA)</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={8}>
                  <TextField
                    fullWidth
                    size="small"
                    value={mobileNumber}
                    onChange={(e) => setMobileNumber(e.target.value)}
                    label="Mobile Number"
                    type="tel"
                    error={!!error}
                    helperText={error}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Submit Button */}
            <Grid item xs={12} sx={{ width: "100%", mt: 2 }}>
              <Button
                variant="contained"
                fullWidth
                onClick={handleUpdate}
                sx={{ textTransform: "none" }}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} /> : "Update Mobile Number"}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
};


export default ProductList;